module.exports = __webpack_public_path__ + "static/media/cooking.87de045f.jpg";